import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  inject,
  Input,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { LogicalQueryNode } from '@blaze-shared/api-contracts-domain';
import { getAllComparisonNodes } from '@blaze-shared/datasets-domain';
import { ClickableDirective } from '@blaze-shared/shared-ui';
import { IconsModule } from '@blaze-shared/theming-data-access';

import { FilterBuilderComponent } from '../filter-builder/filter-builder.component';

@Component({
  selector: 'blaze-filter-builder-trigger',
  templateUrl: './filter-builder-trigger.component.html',
  styleUrls: ['./filter-builder-trigger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconsModule, ClickableDirective],
})
export class FilterBuilderTriggerComponent implements OnChanges, OnDestroy {
  private cdr = inject(ChangeDetectorRef);

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('for') filterBuilder: FilterBuilderComponent | null = null;
  @Input()
  @HostBinding('class.full-width')
  fullWidth = false;

  private filterChangeSubscription = Subscription.EMPTY;

  comparisonFiltersCount = 0;

  ngOnChanges(): void {
    if (!this.filterBuilder) {
      return;
    }

    this.filterChangeSubscription.unsubscribe();
    this.filterChangeSubscription = this.filterBuilder.applyFilter.subscribe((query) => {
      this.comparisonFiltersCount = getAllComparisonNodes(query as LogicalQueryNode).length;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.filterChangeSubscription.unsubscribe();
  }

  toggleFilters(): void {
    if (!this.filterBuilder) {
      return;
    }

    this.filterBuilder.toggleFilters();
  }
}
